import { Tabs, TabsListProps } from "@mantine/core";

import classNames from "classnames";

import { useScrollingTabRow } from "@/hooks/useScrollingTabRow";

/**
 * A `Tabs.List` that scrolls sideways in one line on phones, with the active tab kept in view
 * and the right edge faded while more tabs are off-screen. Works under the shared `Tabs` and
 * under Mantine's own.
 */
export default function ScrollingTabsList({ className, ...props }: TabsListProps) {
  const scrollingRow = useScrollingTabRow();
  return (
    <Tabs.List
      {...props}
      ref={scrollingRow.ref}
      className={classNames(scrollingRow.className, className)}
    />
  );
}
